// OpenAI API configuration settings

// Check if environment variable is loaded
const apiKey = process.env.REACT_APP_OPENAI_API_KEY || '';
const isApiKeyAvailable = !!apiKey && apiKey !== 'your_openai_api_key_here';

console.log("OpenAI API key loaded (cache-bust 2025-09-23):", isApiKeyAvailable ? "Yes" : "No");

export const OPENAI_API_KEY = apiKey;
export const IS_API_KEY_AVAILABLE = isApiKeyAvailable;

// API endpoints for OpenAI
export const OPENAI_CHAT_ENDPOINT = 'https://api.openai.com/v1/chat/completions';

// OpenAI API configuration
export const openaiConfig = {
  model: 'gpt-4o-mini',
  temperature: 0.7,
  max_tokens: 1500
};

// Generate headers for OpenAI API requests
export const getOpenAIHeaders = () => {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${OPENAI_API_KEY}`
  };
};

// Format prompt for OpenAI Chat API - specific to Pathway Planner requirements
export const formatOpenAIChatPrompt = (systemPrompt, userPrompt) => {
  return {
    model: openaiConfig.model,
    messages: [
      {
        role: "system",
        content: systemPrompt
      },
      {
        role: "user",
        content: `${userPrompt}

I need HIGHLY SPECIFIC, actionable recommendations - not general advice. Each step must be concrete and implementable.

IMPORTANT: Your response MUST be a valid JSON object with the following EXACT structure - no preamble or explanation text:
    {
      "data": {
        "recommendations": [
          {
            "path1": {
              "step1": {
                "title": "First specific and actionable step",
                "importance": 20,
                "details": "Detailed implementation instructions with specific techniques, tools, timeframes, and measurable outcomes."
              },
              "step2": {
                "title": "Second specific and actionable step",
                "importance": 15,
                "details": "Detailed implementation instructions with specific techniques, tools, timeframes, and measurable outcomes."
              },
              "step3": {
                "title": "Third specific and actionable step",
                "importance": 25,
                "details": "Detailed implementation instructions with specific techniques, tools, timeframes, and measurable outcomes."
              },
              "step4": {
                "title": "Fourth specific and actionable step",
                "importance": 20,
                "details": "Detailed implementation instructions with specific techniques, tools, timeframes, and measurable outcomes."
              },
              "step5": {
                "title": "Fifth specific and actionable step",
                "importance": 10,
                "details": "Detailed implementation instructions with specific techniques, tools, timeframes, and measurable outcomes."
              },
              "step6": {
                "title": "Sixth specific and actionable step",
                "importance": 10,
                "details": "Detailed implementation instructions with specific techniques, tools, timeframes, and measurable outcomes."
              }
            }
          }
        ]
      }
    }
    
Each step must be a CONCRETE ACTION with specific implementation details. For example:
- Bad: "Create a study plan"
- Good: "Create a 12-week study plan with 2-hour daily focused sessions on specific topics X, Y, Z, with practice tests every Friday"

The importance values must add up to 100. Steps should follow a logical progression where each builds on the previous one.`
      }
    ],
    temperature: openaiConfig.temperature,
    max_tokens: openaiConfig.max_tokens,
    response_format: { type: "json_object" }
  };
};

// Simple chat function for direct OpenAI calls
export const sendChatMessage = async (message, history = []) => {
  if (!IS_API_KEY_AVAILABLE) {
    throw new Error('OpenAI API key not available');
  }

  const messages = [
    {
      role: "system",
      content: "You are Quila, a helpful college application assistant. Provide clear, actionable advice for college applications, essays, and academic planning. Keep responses conversational and supportive."
    },
    ...history.map(msg => ({
      role: msg.role,
      content: msg.content
    })),
    {
      role: "user",
      content: message
    }
  ];

  const response = await fetch(OPENAI_CHAT_ENDPOINT, {
    method: 'POST',
    headers: getOpenAIHeaders(),
    body: JSON.stringify({
      model: openaiConfig.model,
      messages: messages,
      temperature: openaiConfig.temperature,
      max_tokens: openaiConfig.max_tokens
    })
  });

  if (!response.ok) {
    throw new Error(`OpenAI API error: ${response.status} ${response.statusText}`);
  }

  const data = await response.json();
  return data.choices[0].message.content;
}; 